/*eslint-disable */
var $ = window.jQuery = require('jquery')
import commentVideo from './comment-on-video-list';
import {
  mapGetters,
  } from 'vuex';
export default {
  name: 'vista-private-media-details',
  components: {
    'video-comments' : commentVideo
  },
  props: [],
  data() {
    return {
      popularVideosData:null,
      popularVideosResults:[],
      mediaVideoId:'',
      selectedVideoInfoByID:[]
    }
  },
  computed: {
    ...mapGetters([
      'privateVideosListGetters'
    ]),
    getVistaPublicMediaListFun(){
      return this.$store.getters.privateVideosListGetters.data;
    },
  },
  mounted () {
    $('#iframe').contents().find("#toolbarViewerRight").hide();
  },
  created(){
    this.mediaVideoId = this.$route.params.videoID
    this.getSelectedVideoInfoMethod(this.mediaVideoId)
  },
  methods: {
    getSelectedVideoInfoMethod(ID){
      this.$store.dispatch('getPrivateMediaListFun').then((res) => {
        this.selectedVideoInfoByID = res.data.data.filter(media => media.id === ID);
        return this.selectedVideoInfoByID;
      }).catch((err) => {

      })
    },
  },
  watch:{
    getVistaPublicMediaListFun(newData, oldData){
      this.popularVideosData = newData
      this.popularVideosResults = this.popularVideosData 
    },
    '$route.params.videoID'(newId, oldId) {
      this.mediaVideoId = newId
      this.getSelectedVideoInfoMethod(newId)
    }
  },
}